/**
 * OrionKnowledgeBase — Admin
 * Base de connaissance Orion : Documentation (PDF) + Mémoire persistante.
 * Deux onglets internes.
 */

import React, { useState } from 'react';
import { BookOpen, Brain } from 'lucide-react';
import OrionDocumentManagement from './OrionDocumentManagement';
import OrionMemoryManagement from './OrionMemoryManagement';

const TABS = [
  { id: 'docs',   label: 'Documentation', icon: BookOpen },
  { id: 'memory', label: 'Mémoire',        icon: Brain },
];

const OrionKnowledgeBase = () => {
  const [activeTab, setActiveTab] = useState('docs');

  return (
    <div>
      <div className="flex gap-1 border-b border-gray-200 px-4 sm:px-6 lg:px-8 pt-2 mb-4">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-b-2 transition-colors ${
                activeTab === t.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon size={15} />
              {t.label}
            </button>
          );
        })}
      </div>
      {activeTab === 'docs'   && <OrionDocumentManagement />}
      {activeTab === 'memory' && <OrionMemoryManagement />}
    </div>
  );
};

export default OrionKnowledgeBase;
